module.exports = __webpack_public_path__ + "img/ICF_Logo_White.8484de3f.png";